import { gql, useQuery } from 'urql';

const QrCodeQuery = gql`
  query GetAuthQrcodeByUserId($hash: String!, $qrCodeSize: Int!) {
    getAuthQrcodeByUserId(input: { hash: $hash, qrCodeSize: $qrCodeSize })
  }
`;

interface AuthQrCodeResponse {
  getAuthQrcodeByUserId: string;
}

const useFetchQrCodeAdmin = (hash: string, qrCodeSize: number) => {
  const [result] = useQuery<AuthQrCodeResponse>({
    query: QrCodeQuery,
    variables: { hash, qrCodeSize },
    pause: !hash,
    requestPolicy: 'network-only',
  });
  const { data, fetching, error } = result;

  return {
    data,
    fetching,
    error,
  };
};

export default useFetchQrCodeAdmin;
